import { gsap } from "gsap";

import { Scroll } from './_app/cuchillo/scroll/Scroll';
import { VInsider } from './_app/cuchillo/scroll/insiders/VInsider';
// import { ScrollItem__BillboardProject } from './scroll/ScrollItem__BillboardProject';
// import { ScrollItem__Footer } from './scroll/ScrollItem__Footer';
// import { ScrollItem__Photos } from './scroll/ScrollItem__Photos';
// import { ScrollItem__Projects } from './scroll/ScrollItem__Projects';
// import { ScrollItem__About } from './scroll/ScrollItem__About';

import { Accessibility } from './_app/cuchillo/core/Accessibility';
import { Basics, setNetworkSpeed, isDebug, isTouch } from './_app/cuchillo/core/Basics';
import EventDispatcher from './_app/cuchillo/core/EventDispatcher';
import { Interaction } from './_app/cuchillo/core/Interaction';
import { GetBy } from "./_app/cuchillo/core/Element";
import { Metrics } from './_app/cuchillo/core/Metrics';
import { Statics } from './_app/cuchillo/utils/Statics';
import Keyboard from './_app/cuchillo/core/Keyboard';

import LoaderController from './_app/cuchillo/loaders/LoaderController';
import PagesLoader from './_app/cuchillo/loaders/PagesLoader';
import MediaLoader from './_app/cuchillo/loaders/MediaLoader';

import { ControllerPage } from './_app/cuchillo/pages/ControllerPage';
import Page from './_app/cuchillo/pages/Page';
import Default from './pages/Default';
// import Legal from './pages/Legal';
import Contact from './pages/Contact';
import About from './pages/About';
// import Talents from './pages/Talents';
// import Archive from './pages/Archive';
import Project from './pages/Project';
import Projects from './pages/Projects';
import Photos from './pages/Photos';
import Home from './pages/Home';
// import Artist from './pages/Artist';

import BG from './_app/cuchillo/layout/Background';
import InterfaceCanvas from './_app/cuchillo/layout/InterfaceCanvas';
import Header from './layout/Header';
import Loading from './layout/Loading';
import Wrap from './layout/Wrap';

import { ControllerWindow } from './_app/cuchillo/windows/ControllerWindow';
import Win from './_app/cuchillo/windows/Window';
import Preloader from "./layout/Preloader";
import Sidemenu from "./layout/Sidemenu";
import Language from "./_app/cuchillo/utils/Language";
import CMP from "./windows/Cmp";
import BGVideo from "./layout/BGVideo";
import BGImage from "./layout/BGImage";
import CircleVisor from "./layout/CircleVisor";
import Cursor from "./_app/cuchillo/cursor/Cursor";
import VSticky from "./_app/cuchillo/scroll/insiders/VSticky";

export default class Main {
  static stats;
  static current_favicon = 0;
  static domFavicon = GetBy.selector("[data-favicon]")[0];
  static paths;

  static init() {
    setNetworkSpeed(LOADING_TIMER);

    gsap.ticker.fps(60);

    Basics.id = "Ocean_v002"; // ID para cookies 
    Metrics.init(() => Main.resize()); // Tamaños y resize
      
    Language.init();
    Header.init();
    BGVideo.init();
    BGImage.init();
    Sidemenu.init();

    CircleVisor.init();

    
    Keyboard.enable(); // ESC para cerrar ventana
    Accessibility.init(); // Utils accesibilidad
    Statics.init(true); // Si estamos en debug pinta un FPS counter
    Interaction.init({ ajax: true }) // Posiciones del cursor (Movimiento, click...), Acciones links, drag...
    ControllerWindow.init(); // Control ventanas

    BG.init(CMS_COLORS); // Control de paletas y color de fondo de pantallas. Automatico si añadimos un data-palette='loquesea' en el div con data-page
    InterfaceCanvas.init(); // Canvas de interface, se usa con Cursor
    CMP.init(); // Checkea y saca el aviso de cookies
    Cursor.init(document.body, { isMoveCancel: true });

    LoaderController.add(new PagesLoader()); // Carga/Precarga de paginas HTML
    LoaderController.add(new MediaLoader()); // Carga/Precarga de imgs
    LoaderController.update = progress => Preloader.update(progress);
    LoaderController.onComplete = () => Main.setup();

    Main.doCuchilloInfo();
    Main.setWorker();
    Main.initLoop();
    
    Preloader.init();
    Preloader.show(()=> {
      LoaderController.init();
    });
  }

  static setup() {
    Main.setupEvents();
    // INIT PAGE
    ControllerPage.init(Wrap.mainholder);
  }

  static setupEvents() {
    EventDispatcher.addEventListener(Page.ON_SHOW, () => {
      Cursor.start();
      Loading.stop();
    });
    EventDispatcher.addEventListener(Page.ON_HIDE, () => {
      Cursor.hide();
      Sidemenu.hide();
    });
    EventDispatcher.addEventListener(Page.ON_HIDE_END, () => {
      Loading.start();
    });

    EventDispatcher.addEventListener(Win.ON_HIDE, () => { Scroll.setEnabled(true); });
    EventDispatcher.addEventListener(Win.ON_SHOW, () => { Scroll.setEnabled(false); });
    EventDispatcher.addEventListener(Sidemenu.ON_HIDE, () => { Scroll.setEnabled(true); });
    EventDispatcher.addEventListener(Sidemenu.ON_SHOW, () => {
      Scroll.setEnabled(false);
      ControllerWindow.hideAll();
    });

   
  }

  static initLoop() {
    // LOOP
    if (isDebug) {
      gsap.ticker.add(() => { Main.loopDebug(); });
    } else {
      gsap.ticker.add(() => { Main.loop(); });
    }
  }

  static resize() {

    Header.resize();
    Sidemenu.resize();
    InterfaceCanvas.resize();
    BG.resize();
    ControllerPage.resize();
    //Guides.resize();
    CircleVisor.resize();

    Cursor.resize();
    if (isTouch) GetBy.id('Main').style.height = `${Metrics.HEIGHT}px`;
  }

  static loop() {
    InterfaceCanvas.loop();

    ControllerPage.loop();
    BG.loop();
    Header.loop();
    Sidemenu.loop();
    CircleVisor.loop();

    Cursor.loop();

    if (Scroll.isScrolling) Scroll.loop();

    //Main.changeFavicon();
  }

  static changeFavicon() {
    Main.domFavicon.setAttribute("href", `/assets/favicons/${Main.favicons[Main.current_favicon]}/favicon.ico`);
    Main.current_favicon = Main.current_favicon < 99 ? Main.current_favicon + 1 : 0;
  }

  static loopDebug() {
    Statics.begin();
    Main.loop();
    //Guides.loop();
    Statics.end();
  }

  static doCuchilloInfo() {
    console.log('%cby Cuchillo', 'background: #000; color: #bada55; padding:25px 100px;');
    console.log('⟶ http://somoscuchillo.com');
    console.log('⟶ https://www.instagram.com/_cuchillo');
    console.log('⟶ https://twitter.com/somoscuchillo');
    console.log('⟶ https://twitter.com/mr__corrales');
    console.log('');
    console.log('Gsap by Greenshock');
    console.log('⟶ https://greensock.com');
    console.log('');
    console.log('Font: Fraktion Mono by Pangram Pangram');
    console.log('⟶ https://pangrampangram.com/products/fraktion');
    console.log('');
    console.log('SVGOMG');
    console.log('⟶ https://jakearchibald.github.io/svgomg/');
    console.log('');
    console.log('Favicon Generator');
    console.log('⟶ https://realfavicongenerator.net');
  }

  static setWorker() {
    if ('serviceWorker' in navigator && !isDebug) {
      navigator.serviceWorker
        .register('/service-worker.js')
        .then(function () { });
    }
  }
}

if (document.attachEvent ? document.readyState === "complete" : document.readyState !== "loading") {
  Main.init();
} else {
  document.addEventListener('DOMContentLoaded', Main.init);
}
